module.exports = __webpack_public_path__ + "img/xq-light.ec7a48c.png";